import React from 'react'

const AdminForm = ({
    id: key,
    majRecette,
    recettes,
    supprimerRecette
}) => {
    const recette = recettes[key]

    const handleChange = (event, key) => {
        const {name, value} = event.target
        const recette = recettes[key]
        recette[name] = value 
        majRecette(key, recette)
    }
    return (
        <div className="card">
            <form className="admin-form " >
                    <input name="nom" value={recette.nom} onChange={e => handleChange(e, key)} type="text" placeholder="Nom de la recette" />
                    <input name="image" value={recette.image} onChange={e => handleChange(e, key)} type="text" placeholder="Nom de l'image" />
                    <textarea name="ingredients" value={recette.ingredients} onChange={e => handleChange(e, key)} rows="3" placeholder="Nom des ingredients" ></textarea>
                    <textarea name="instructions" value={recette.instructions} onChange={e => handleChange(e, key)} rows="15" placeholder="Nom des instructions" ></textarea>
                </form>
                <button onClick={() => supprimerRecette(key)}>Supprimer</button>
        </div>
    )
}

export default AdminForm